export const BACKEND_URL = 'https://backend.cocoa-app.com'
// export const BACKEND_URL = 'http://localhost:8081'
//
